// extracted by mini-css-extract-plugin
export var completionBody = "_lg-2";
export var completionCard = "_lg-0";
export var completionFooter = "_lg-3";
export var completionTitle = "_lg-1";